import styled from "styled-components";

import { pxToRem } from "../../styles/utils";
import { CoursesPageLead } from "./studentCourses.styles";

export const CoursesSectionHeader = styled.div`
  padding-bottom: ${({ theme }) => pxToRem(theme.spacing.xl)};

  ${CoursesPageLead} {
    margin-bottom: 0;
  }
`;
